module.exports = __webpack_public_path__ + "img/img4.072c6a9c.jpg";